import React from "react";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import { makeStyles } from "@material-ui/core/styles";
import { useGerencia } from "../../Context/GerenciaContext";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import FormGerencia from "../../Component/Form/Gerencia";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ModalDelete from "../../Component/Modal/ModalDeleteGerencia";
import ModalSuccess from "../../Component/Modal/ModalExitoGerencia";

const useStyles = makeStyles(style);

const GerenciaContent = () => {
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const { 
    miningSite,
    setMiningSite,
    selected,
    setSelected,
    nameFilter,
    setNameFilter,
    idFilter,
    setIdFilter,
    departments,
    setDeleteItem,
  } = useGerencia();

  const filterDisabled = miningSite === 0;

  const classes = useStyles();

  const handleClickDepartment = (item) => {
    setSelected(item);
  };

  return (
    <div className={classes.content}>
      <Grid container className={classes.gerencia}>
        <Grid item xs={12} className={classes.filter}>
          <FormControl
            variant="outlined"
          >
            <Select
              className={classes.filterSelect}
              value={miningSite}
              onChange={(e) => {
                setMiningSite(e.target.value);
              }}
            >
              <MenuItem value={0}>Seleccione una planta</MenuItem>
              {miningSites.map((res, key) => {
                return (
                  <MenuItem key={key} value={res.id}>
                    {res.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Paper className={classes.filterInput}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={idFilter}
                placeholder="Buscar por id"
                onChange={(e) => setIdFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Paper className={classes.filterInput}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                placeholder="Buscar por el nombre"
                value={nameFilter}
                onChange={(e) => setNameFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
        </Grid>
        <Grid item xs={4} className={classes.listAdd}>
          <h3 className={classes.title}>Lista de las Gerencias</h3>
          <List className={classes.listGerencia}>
            {departments.map((item, index) => (
              <ListItem
                button
                id={item.departmentId}
                className={
                  classes.Listbutton +
                  (selected && selected.departmentId === item.departmentId ? " active-item" : null)
                }
                onClick={() => handleClickDepartment(item)}
                key={index}
              >
                <ListItemText primary={item.departmentDescription} />
                {selected && selected.departmentId === item.departmentId ? (
                  <button
                    id={item.departmentId}
                    className={classes.iconClose}
                    onClick={() => setDeleteItem(item)}
                  >
                    <CloseIcon />
                  </button>
                ) : null}
              </ListItem>
            ))}
          </List>
          {miningSite === 0 ? null : (
            <button
              className={classes.iconMore}
              onClick={() => setSelected({
                departmentId: 0,
                departmentDescription: "",
                isOutsourcing: -1,
              })}
            >
              <AddIcon />
            </button>
          )}
        </Grid>
        <Grid item xs={8} className={classes.formGerencia}>
          <h3 className={classes.title}>Datos de la Gerencia</h3>
          {selected ? (
            <FormGerencia />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No hay gerencia seleccionada{" "}
            </div>
          )}
        </Grid>
      </Grid>
      <ModalDelete />
      <ModalSuccess />
    </div>
  );
};

export default GerenciaContent;
